const navMenu = [
  {
    url: "/",
    name: "Home",
  },
  {
    url: "/blog",
    name: "Blog",
  },
  {
    url: "/works",
    name: "Our Works",
  },
];

export default navMenu;
